import styled from 'styled-components';
import { colorCSS, radius } from '../../../styles';
export const Button = styled.a `
  background-color: ${colorCSS('N0')};
  border: 1px solid ${colorCSS('P200')};
  border-radius: ${radius['button']};
  color: ${colorCSS('N800')};
  display: inline-block;
  font-size: 1rem !important;
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  text-decoration: none;
  &:hover {
    background-color: ${colorCSS('P50')};
    color: ${colorCSS('N800')};
  }
`;
//# sourceMappingURL=SecondaryButton.styles.js.map